import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';

export interface GeneralResponse {
    data: GeneralResponseBody;
}
export interface GeneralResponseBody {
    data: Array<QuestionType>;
    limit: number;
    message: string;
    page: number;
    totalCount: number;
    totalPages: number;
    warnings: Array<string>;
    count: number;
}
export interface QuestionType {
    id: string;
    code: string;
    name: string;
}
export const fetchQuestionTypes = createAction<
    fetchQuestionTypesAction | undefined
>(ActionTypes.FETCH_QUESTION_TYPES);
export const fetchQuestionTypesSuccess =
    createAction<fetchQuestionTypesSuccessAction>(
        ActionTypes.FETCH_QUESTION_TYPES_SUCCESS,
    );
export const fetchQuestionTypesFailed =
    createAction<fetchQuestionTypesFailedAction>(
        ActionTypes.FETCH_QUESTION_TYPES_FAILED,
    );

export interface fetchQuestionTypesAction {
    type?: typeof ActionTypes.FETCH_QUESTION_TYPES;
}

export interface fetchQuestionTypesSuccessAction {
    type: typeof ActionTypes.FETCH_QUESTION_TYPES_SUCCESS;
    body: GeneralResponse;
}

export interface fetchQuestionTypesFailedAction {
    type: typeof ActionTypes.FETCH_QUESTION_TYPES_FAILED;
    payload: GeneralResponse | any;
}
